import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_bettingslip_calculator_modal',
    templateUrl: './bettingslip_calculator_modal.html',
})
export class BettingSlipCalculatorModal implements OnInit {
    @Output('calculator_Modal_Ok') public calculator_Modal_Ok = new EventEmitter();
    public Calculator_Input_Value = '';
    public init: boolean;

    public moneyList = [10, 20, 50, 100, 200, 500, 1000];
    constructor(public tournamentsService: TournamentsService) {}

    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
        this.Calculator_Input_Value = '';
    }

    public CalculatorModal_ChangeValue(e, isChange?) {
        if (isChange) {
            this.Calculator_Input_Value = e + '';
            this.CalculatorModal_Ok();
        } else {
            if (e == 0 && this.Calculator_Input_Value == '0') {
                return;
            }
            let money = this.Calculator_Input_Value + '';
            money += e;
            this.Calculator_Input_Value = money;
        }
    }

    public CalculatorModal_Cancel() {
        this.Calculator_Input_Value = this.Calculator_Input_Value.slice(0, -1);
    }

    public CalculatorModal_Close() {
        this.Calculator_Input_Value = '';

        $('#BettingSlip_Calculator_Modal').modal('hide');
    }

    public CalculatorModal_Ok() {
        if (isNaN(parseFloat(this.Calculator_Input_Value))) {
            this.tournamentsService.CalculatorValue = 2;
        } else if (parseFloat(this.Calculator_Input_Value) == 0) {
            this.tournamentsService.CalculatorValue = 2;
        } else {
            this.tournamentsService.CalculatorValue = parseFloat(this.Calculator_Input_Value);
            this.calculator_Modal_Ok.next(this.Calculator_Input_Value);
        }
        this.Calculator_Input_Value = '';
        this.tournamentsService.changeSlipAmount(
            ((Number(this.tournamentsService.CalculatorValue) * 100) / (100 + this.tournamentsService.tax)).toFixed(4),
            this.tournamentsService.BettingSlip_Menu_SlipType,
        );
        $('#BettingSlip_Calculator_Modal').modal('hide');
    }
}
